import React from "react";
import ReactDom from "react-dom";
import RegistrationForm from "./RegistrationForm.jsx";

export function initRegistrationForm() {
  const div = document.querySelector(".js-registration-form-mount");
  if (div) {
    // Extract data attributes
    const howDidYouHearItems = div.getAttribute("data-howdidyouhearitems");
    const countries = div.getAttribute("data-countries");
    const states = div.getAttribute("data-states");
    const googleSiteKey = div.getAttribute("data-google-sitekey");
    const underwriterOptions = div.getAttribute("data-underwriter-options");
    const dataSourceId = div.getAttribute("data-datasource-id");

    // Parse JSON attributes if they exist
    const parsedHowDidYouHearItems = howDidYouHearItems
      ? JSON.parse(howDidYouHearItems)
      : null;
    const parsedCountries = countries ? JSON.parse(countries) : null;
    const parsedStates = states ? JSON.parse(states) : null;
    const parsedUnderwriterOptions = underwriterOptions
      ? JSON.parse(underwriterOptions)
      : null;

    ReactDom.render(
      <RegistrationForm
        howDidYouHearItems={parsedHowDidYouHearItems}
        countries={parsedCountries}
        states={parsedStates}
        googleSiteKey={googleSiteKey}
        underwriterOptions={parsedUnderwriterOptions}
        dataSourceId={dataSourceId}
      />,
      div,
    );
  }
}
